import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, Btn, Input } from "@/components/erp/ui";
import { MediaInput } from "@/components/erp/prod/ProdInputs";
import { useFlow, WoHead, Denied, err, uploadFlow } from "@/components/erp/flow/FlowCommon";
import { BACKEND } from "@/components/erp/prod/ProdInputs";

const PackCard = ({ w, load }) => {
  const [inn, setInn] = useState([]); const [out, setOut] = useState([]); const [inv, setInv] = useState(false); const [note, setNote] = useState("");
  const save = async () => { try { await api.post(`/flow/${w.wo_id}/packing`, { inner_photos: inn, outer_photos: out, invoice_included: inv, note }); toast.success("Packing tercatat — lanjut pengiriman"); load(); } catch (e) { err(e); } };
  return (
    <div>
      <div className="text-xs mb-2" data-testid={`pack-team-${w.wo_code}`}>Dipacking oleh: <b>{w.has_finishing ? "Tim Finishing" : "Tim Produksi"}</b></div>
      <div className="grid sm:grid-cols-2 gap-3">
        <MediaInput value={inn} onChange={setInn} max={4} uploader={uploadFlow} testid={`pack-inner-${w.wo_code}`} label="Foto isi dalam packing" />
        <MediaInput value={out} onChange={setOut} max={4} uploader={uploadFlow} testid={`pack-outer-${w.wo_code}`} label="Foto luar packing" />
      </div>
      <label className="flex items-center gap-2 text-sm mt-3"><input type="checkbox" data-testid={`pack-invoice-${w.wo_code}`} checked={inv} onChange={(e) => setInv(e.target.checked)} /> Invoice{w.invoice ? ` ${w.invoice.code}` : ""} & surat jalan dimasukkan ke dalam packing</label>
      {w.invoice && <a className="text-xs text-sky-700 underline" target="_blank" rel="noreferrer" href={`${BACKEND}/api/public/invoice/${w.invoice.id}/termin/0/pdf`} data-testid={`pack-invoice-pdf-${w.wo_code}`}>Cetak invoice</a>}
      <Input className="mt-2" placeholder="Catatan (kondisi, jumlah koli…)" value={note} onChange={(e) => setNote(e.target.value)} />
      <Btn className="mt-3" data-testid={`pack-save-${w.wo_code}`} disabled={!inn.length || !out.length} onClick={save}>Selesai packing</Btn>
    </div>
  );
};

export default function PackingDashboard() {
  const { d, load, denied } = useFlow("PACK");
  if (denied) return <Denied />;
  if (!d) return <div className="p-6 text-sm text-slate-400">Memuat…</div>;
  return (
    <div data-testid="packing-page">
      <PageHeader title="Dashboard Packing" subtitle="Tanpa finishing → tim produksi · dengan finishing → tim finishing · foto isi dalam & luar sebagai bukti" />
      <div className="space-y-3">{d.wos.map((w) => <WoHead key={w.wo_id} w={w}><PackCard w={w} load={load} /></WoHead>)}</div>
      {!d.wos.length && <p className="text-sm text-slate-400" data-testid="pack-empty">Belum ada unit yang disetujui customer untuk dipacking.</p>}
    </div>
  );
}
